import { FormControlLabel, Stack, Switch, TextField } from '@mui/material'
import LightbulbIcon from '@mui/icons-material/Lightbulb'
import { useTranslation } from 'react-i18next'

import { TestCreateSection } from '../TestCreateSection'

/**
 * Подсказки прогона: что ученику разрешено открывать во время теста.
 *
 * Вход до старта урока (`prepMinutes`) живёт здесь же, но только у теста из
 * урока: у самостоятельного теста нет ни урока, ни его расписания, поэтому
 * блок передаётся как необязательный, а не прячется флагом внутри.
 */
export function TestHintsSection({
  allowHints,
  onAllowHintsChange,
  transcription,
  prepMinutes,
}: {
  allowHints: boolean
  onAllowHintsChange: (value: boolean) => void
  /** Только там, где возможен устный ответ: иначе транскрипции не будет вовсе. */
  transcription?: {
    value: boolean
    onChange: (value: boolean) => void
  }
  /** Только тест из урока: за сколько минут до начала открыть вход. */
  prepMinutes?: {
    value: number | ''
    onChange: (value: number | '') => void
  }
}) {
  const { t } = useTranslation()

  return (
    <TestCreateSection
      id="hints"
      icon={<LightbulbIcon fontSize="small" />}
      title={t('tests.createForm.sectionHints')}
    >
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        <FormControlLabel
          control={<Switch checked={allowHints} onChange={(e) => onAllowHintsChange(e.target.checked)} />}
          label={t('tests.form.allowHints')}
        />
        {transcription ? (
          <FormControlLabel
            control={
              <Switch
                checked={transcription.value}
                onChange={(e) => transcription.onChange(e.target.checked)}
              />
            }
            label={t('tests.form.allowTranscription')}
          />
        ) : null}
      </Stack>
      {prepMinutes ? (
        <TextField
          size="small"
          type="number"
          label={t('tests.form.prepMinutesBeforeStart')}
          value={prepMinutes.value}
          onChange={(e) => {
            const v = e.target.value
            prepMinutes.onChange(v === '' ? '' : Number(v))
          }}
          inputProps={{ min: 0, max: 30 }}
          helperText={t('tests.form.prepMinutesBeforeStartHelp')}
          sx={{ maxWidth: 320 }}
        />
      ) : null}
    </TestCreateSection>
  )
}
